import { actionTypes } from './actions'
import { constants } from '../../constants'
import { util } from '../../util'

const initialState = {
    common_error: '',
    is_side_menu_opened: false,
    pageNotifications: null,
    adp_configurations: {},
    has_adp_configurations_failed: false,
    config_loading: false,
    fetching_language: false,
    config_restriction: '',
    current_page: '',
    regions: {},
}

const commonReducer = (state = initialState, action) => {
    const { type, payload } = action
    const { shallowHelper } = util

    switch (type) {
        case actionTypes.SET_COMMON_ERROR: {
            return shallowHelper(state, { common_error: payload })
        }
        case actionTypes.CLEAR_COMMON_ERROR: {
            return shallowHelper(state, { common_error: '' })
        }
        case actionTypes.SIDE_MENU_OPENED: {
            return shallowHelper(state, { is_side_menu_opened: true })
        }

        case actionTypes.SIDE_MENU_CLOSED: {
            return shallowHelper(state, { is_side_menu_opened: false })
        }

        case actionTypes.SET_PAGE_NOTIFICATION: {
            return shallowHelper(state, { pageNotifications: payload })
        }

        case actionTypes.CLEAR_PAGE_NOTIFICATION: {
            return shallowHelper(state, { pageNotifications: null })
        }

        case actionTypes.FETCH_ADP_CONFIGURATIONS_SUCCESS: {
            // complete other configuration flags based on constants.configFeatureFlags
            const featureFlags = Object.keys(constants.configFeatureFlags).map(k => {
                const key = constants.configFeatureFlags[k]
                const payloadFeatureConfig = payload.feature_flag.find(o => o.key === key)
                return (
                    payloadFeatureConfig || {
                        is_active: false,
                        data: {},
                        name: k.toLowerCase(),
                        key: key,
                        type: 'feature_flag',
                    }
                )
            })
            return shallowHelper(state, {
                adp_configurations: {
                    ...payload,
                    feature_flag: featureFlags,
                    regions: payload.regions[0].data,
                },
                config_loading: false,
                has_adp_configurations_failed: false,
            })
        }

        case actionTypes.FETCH_ADP_CONFIGURATIONS_FAILED: {
            return shallowHelper(state, {
                adp_configurations: {},
                has_adp_configurations_failed: true,
            })
        }

        case actionTypes.CONFIG_LOADING_START: {
            return shallowHelper(state, { config_loading: true })
        }

        case actionTypes.CONFIG_LOADING_END: {
            return shallowHelper(state, { config_loading: false })
        }

        case actionTypes.FETCHING_LANGUAGE_START: {
            return shallowHelper(state, { fetching_language: true })
        }

        case actionTypes.FETCHING_LANGUAGE_END: {
            return shallowHelper(state, { fetching_language: false })
        }

        case actionTypes.SET_CONFIGURATION_RESTRICTION: {
            return shallowHelper(state, { config_restriction: payload })
        }

        case actionTypes.CLEAR_CONFIGURATION_RESTRICTION: {
            return shallowHelper(state, { config_restriction: '' })
        }

        case actionTypes.FETCH_REGIONS_CONFIGURATIONS_SUCCESS: {
            return shallowHelper(state, {
                ...payload,
                regions: payload.regions,
            })
        }

        case actionTypes.FETCH_REGIONS_CONFIGURATIONS_FAILED: {
            return shallowHelper(state, {
                regions: {},
            })
        }

        default:
            return state
    }
}

export default commonReducer
